
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface SolutionSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  viewType: string;
  setViewType: (type: string) => void;
}

const SolutionSearch: React.FC<SolutionSearchProps> = ({
  searchQuery,
  setSearchQuery,
  viewType,
  setViewType
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="relative w-full max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input 
          placeholder="Search solutions..." 
          className="pl-10"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <Tabs defaultValue="list" value={viewType} onValueChange={setViewType} className="w-[200px]">
        <TabsList>
          <TabsTrigger value="list">List</TabsTrigger>
          <TabsTrigger value="grid">Grid</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};

export default SolutionSearch;
